// lib/axiom/client.ts
'use client'; // Mark this module for client-side usage

// No longer need direct client import
// import axiomClient from '@/lib/axiom/axiom';
import { ProxyTransport, Logger } from '@axiomhq/logging'; // Use ProxyTransport
import { nextJsFormatters } from '@axiomhq/nextjs/client';
import { ReactNode } from 'react';

// No need for dataset or token here anymore

// Create a logger instance specifically for the client
const clientLogger = new Logger({
  transports: [
    // Point to your proxy API route
    new ProxyTransport({ url: '/api/axiom' }),
  ],
  formatters: nextJsFormatters,
});

// Create custom hooks for client-side logging
export const useLogger = (): Logger => clientLogger;

// Create a component to capture Web Vitals
export const WebVitals = (): ReactNode => {
  // This is a placeholder component that will be replaced with actual implementation
  // when the correct Axiom package versions are installed
  return null;
};

// Re-export for easy import in client components
export { Logger };
